import aboutpic from "./components/Access/mePhoto.jpg"
import weatherwiseLogo from "./components/images/weatherwisetile.jpg"
import Fountlogotile from "./components/images/Fountlogotile.jpg"
import ScreenSurferTile from "./components/images/ScreenSurferTile.jpg"
import scheduleprotile from "./components/images/scheduleprotile.jpg"
import securekeytile from "./components/images/securekeytile.jpg"
import techhubtile from "./components/images/techhubtile.jpg"

const header = {
 
}

const about = {
  photo:aboutpic,
  // all the properties are optional - can be left empty or deleted
  name: 'Brett Russell Bates',
  role: 'Full Stack Developer',
  description:
    'Carpenter turned full stack web developer with a passion for creating useful applications. My career as a carpenter started by learning from my dad right out of high school. Over the years, my specialty became rough carpentry, or framing the skeleton of a project. As my family grew, so did my ambition to develop and provide. Thus began my journey to digitize my framing skills. I can confirm carpentry and coding are nothing alike outside of the words framing and skeleton. Today, I am seeking work as a full-stack developer. My time is also spent leading the worship team at church where I exercise my passion for singing and playing guitar. My weekends often consist of watching the Chiefs and exploring downtown Kansas City with my wife, Claire. My goal is to join a team that encourages new ideas, learning and career growth.',
  resume: 'https://acrobat.adobe.com/link/review?uri=urn:aaid:scds:US:2022ed87-5b55-340b-8b9a-f853b9da687c',
  social: {
    linkedin: 'https://www.linkedin.com/in/brett-russell-bates-3b3a0524a/',
    github: 'https://github.com/brbates86',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    
    URL: 'https://brbates86.github.io/WeatherWise/',
    backgroundImage: weatherwiseLogo,
  },
  {
    
    URL: 'https://thefountkc.com',
    backgroundImage: Fountlogotile,
  },
  {
    
    URL: 'https://morning-tundra-56106.herokuapp.com/',
    backgroundImage: ScreenSurferTile,
  },
  {
    
    URL: 'https://arcane-ravine-15281.herokuapp.com/',
    backgroundImage: techhubtile,
  },
  {
    
    URL: 'https://brbates86.github.io/SecureKey/',
   backgroundImage: securekeytile,
  },
  {
    
    URL: 'https://brbates86.github.io/SchedulePro/',
    backgroundImage: scheduleprotile,
  },
  
]
  


const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'JavaScript',
  'Express',
  'Node.js',
  'MySQL',
  'MongoDB',
  'React',
  'Heroku',
  'Adobe Illustrator'
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'brettbates86@gmail.com'
}

export { header, about, projects, skills, contact }
